const BASE_URL = 'https://reestr.mammulk.kg:5555/api';
// const BASE_URL = 'http://localhost:1337/api';

export const API = {
  BASE_URL: BASE_URL,
  register: `${BASE_URL}/auth/local/register`,
  login: `${BASE_URL}/auth/local`,
  confiscatedObjects: `${BASE_URL}/confiscated-objects?populate=*`,
  profile: `${BASE_URL}/users/me`,
  getTableSchemaUrl: (endpoint) => `${BASE_URL}/table-schema/${endpoint}`

};
